/**
 * Day-of-week color convention for the EnviroLite schedule map.
 *
 * Jim's long-standing Google Maps scheme (2026-06): Monday green, Tuesday blue,
 * Wednesday red, Thursday grey, Friday yellow. Saturday purple and Sunday
 * orange were added when weekend days joined the schedule (JIM-1030-08);
 * anything unknown falls back to slate so a pin still renders.
 */
export const DAY_COLORS: Record<string, string> = {
  Monday: '#22c55e', // green-500
  Tuesday: '#3b82f6', // blue-500
  Wednesday: '#ef4444', // red-500
  Thursday: '#9ca3af', // gray-400
  Friday: '#eab308', // yellow-500
  Saturday: '#a855f7', // purple-500
  Sunday: '#f97316', // orange-500
};

export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

const FALLBACK_COLOR = '#64748b'; // slate-500

/** Color for a full day name ("Monday" … "Sunday"); slate for unknown. */
export function dayColorFromName(dayName?: string | null): string {
  if (!dayName) return FALLBACK_COLOR;
  return DAY_COLORS[dayName] ?? FALLBACK_COLOR;
}
